import { useState } from 'react';
import { feedbackService } from '@/services/feedbackService';
import { FeedbackRequest, FeedbackResponse } from '@/types/feedback';

export function useSubmitFeedback() {
  const [isPending, setIsPending] = useState(false);
  const [error, setError] = useState<Error | null>(null);
  const [isError, setIsError] = useState(false);

  const mutateAsync = async (request: FeedbackRequest): Promise<FeedbackResponse> => {
    setIsPending(true);
    setError(null);
    setIsError(false);

    try {
      const response = await feedbackService.submitFeedback(request);
      return response;
    } catch (err) {
      const error = err as Error;
      setError(error);
      setIsError(true);
      throw error;
    } finally {
      setIsPending(false);
    }
  };

  return {
    mutateAsync,
    isPending,
    error,
    isError,
  };
}
